export default __webpack_public_path__ + "static/media/ship.4f2f8c85.svg";